<template lang="pug">
.v-btn-scroll-top.btn-scroll-top(:class="{'btn-scroll-top--visible': isVisible}")
	button.btn-scroll-top__btn(type="button" @click="scrollToTop")
		v-svg-icon.btn-scroll-top__icon(icon="arrow-right")
</template>

<script>

import smoothScrollTo from '/local/assets/source/scripts/view/modules/global/smoothScrollTo.js';

export default {
	data() {
		return {
			isVisible: false,
		};
	},

	mounted() {
		window.addEventListener('scroll', this.setVisibility, this.passiveEventsSupported ? {passive: true} : undefined);
	},

	methods: {
		passiveEventsSupported() {
			// passive event listeners support test from MDN
			let result = false;
			try {
				window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
					get: () => result = true
				}));
			} catch (err) {}
			return result;
		},

		setVisibility() {
			if (window.scrollY > 500) {
				this.isVisible = true;
			} else {
				this.isVisible = false;
			}
		},

		scrollToTop() {
			smoothScrollTo(0, 800, null, false);
		}
	}
};
</script>
